import { render, staticRenderFns } from "./TicketSettingsEditDialog.vue?vue&type=template&id=dc137176&"
import script from "./TicketSettingsEditDialog.vue?vue&type=script&lang=ts&"
export * from "./TicketSettingsEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports